import { Text, Link, Box, Flex, useTooltip, BoxProps } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { ContextApi } from 'contexts/Localization/types'
import HealthIconImage from 'views/VvsGotchi/components/HealthIconImage'
import { FULL_HEALTH_LUCKY_DRAW_URL } from 'config/constants/vvsgotchi'
import { HEALTH_LEVEL_VALUES } from 'views/VvsGotchi/config'

import MeterBarSvg from './MeterBarSvg'

import { HealthMeterBox, HealthStatsFlex, Gift } from './styles'

/**
 * meter UI widget showing health point, ranging from 0 to 100
 */
const HealthMeter: React.FC<{ health?: number } & BoxProps> = ({ health, ...props }) => {
  const { t } = useTranslation()
  const hasHealth = typeof health === 'number'

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <Text color="white">
      {t('Hit 100 health points to enter our lucky draw!')}{' '}
      <Link href={FULL_HEALTH_LUCKY_DRAW_URL} inline linkColor="primary" target="_blank" rel="noreferer noopener">
        {t('Visit our discord channel')}
      </Link>
    </Text>,
    {
      placement: 'top-end',
      tooltipOffset: [10, 10],
    },
  )

  return (
    <HealthMeterBox {...props}>
      <MeterBarSvg health={health ?? 0} />

      <HealthStatsFlex>
        <Box>
          <Text as="span" color="black" fontSize={['32px', '42px']} px="10px">
            {hasHealth ? Math.floor(health) : '?'}
          </Text>
          <Text as="span" color="black" fontSize={['16px', '24px']} fontWeight="600">
            / 100
          </Text>
        </Box>

        {hasHealth && (
          <Flex alignItems="center" gap="5px">
            <Text fontSize="13px" fontWeight="500" color="black">
              {getHealthRangeText(health, t)}
            </Text>
            <HealthIconImage health={health} />
          </Flex>
        )}
      </HealthStatsFlex>

      {hasHealth && (
        <>
          {tooltipVisible && tooltip}
          <Gift ref={targetRef} src="/images/vvsGotchi/mysteryBox.png" />
        </>
      )}
    </HealthMeterBox>
  )
}

export default HealthMeter

const getHealthRangeText = (health: number, t: ContextApi['t']) => {
  if (health >= HEALTH_LEVEL_VALUES.excellent) return t('100: Excellent')
  if (health >= HEALTH_LEVEL_VALUES.healthy) return t('71-99: Healthy')
  if (health >= HEALTH_LEVEL_VALUES.normal) return t('61-70: Normal')
  if (health >= HEALTH_LEVEL_VALUES.unhealthy) return t('11-60: Unhealthy')
  return t('0-10: Sick') // HEALTH_LEVEL_VALUES.sick
}
